// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ge8vRZeaMU_ApE {
  position: absolute;
  z-index: -1;
  bottom: -5px;
  width: calc(100% - 8px);
  height: 5px;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  border-radius: 0 0 8px 8px;
  object-fit: cover;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardHint": `Ge8vRZeaMU_ApE`
};
export default ___CSS_LOADER_EXPORT___;
